import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-photo",
  templateUrl: "./med-icon-photo.component.html",
})
export class MedIconPhotoComponent extends SvgMixinComponent {}
